import { render, staticRenderFns } from "./ManageOrganization.vue?vue&type=template&id=9e6254d2&scoped=true&"
import script from "./ManageOrganization.vue?vue&type=script&lang=js&"
export * from "./ManageOrganization.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrganization.vue?vue&type=style&index=0&id=9e6254d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6254d2",
  null
  
)

export default component.exports